Vendd.Scripts.load(function () {

    var factoriesDictionary = {};

    var controlFactory = function () {

    };

    controlFactory.prototype.register = function (name, factory) {

        factoriesDictionary[name] = factory;

    };

    controlFactory.prototype.Resolve = function (wrapper) {

        var results = [];

        Object.keys(factoriesDictionary).forEach(function (x) {

            results = results.concat(factoriesDictionary[x]());

        });

        return results;

    };

    controlFactory.prototype.destroy = function () {

        factoriesDictionary = undefined;

    };

    var Vendd = window.Vendd || {};

    Vendd.inlineEdit.controlFactory = new controlFactory();

});